import script from "./qrcodeQuery.vue?vue&type=script&lang=ts&setup=true"
export * from "./qrcodeQuery.vue?vue&type=script&lang=ts&setup=true"

import "./qrcodeQuery.vue?vue&type=style&index=0&id=1afc2162&lang=css"

const __exports__ = script;

export default __exports__